// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBdv3lwed5h4KoodWuROJiIsOSwp05m2FA",
  authDomain: "chatapp-4728d.firebaseapp.com",
  projectId: "chatapp-4728d",
  storageBucket: "chatapp-4728d.firebasestorage.app",
  messagingSenderId: "560816288111",
  appId: "1:560816288111:web:e01249e07f278d456db89a",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
